import { customFetchV2 } from "../../../services/custom-fetch-v2.ts";

class GeofenceApiService {
  save(payload) {
    return customFetchV2(`/geofences/${payload.id}`, {
      method: 'PUT',
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Unable to create geofence - HTTP response ${response.status}`);
        }
      });
  }

  delete(id) {
    return customFetchV2(`/geofences/${id}`, {
      method: 'DELETE',
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Unable to delete geofence - HTTP response ${response.status}`);
        }
      });
  }

  list() {
    return customFetchV2('/geofences', {
      method: 'GET',
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Unable to list geofences - HTTP response ${response.status}`);
        }

        return response.data;
      });
  }
}

export default GeofenceApiService;
